(function () {
    'use strict';

    angular.module('document')
        .service('DocumentConfigService', DocumentConfigService);

    DocumentConfigService.$inject = ['serviceBase'];
    function DocumentConfigService(serviceBase) {
        return {
            deleteDocumentPath: serviceBase + '/road-monitoring/document/remove/',
            uploadDocumentPath: serviceBase + '/road-monitoring/document/',
            getDocumentListPath: serviceBase + '/road-monitoring/document/',
            getDocumentPath: serviceBase + '/road-monitoring/document/'
        };
    }
})();
